module.exports = __webpack_public_path__ + "resources/img/banner-1.33054807.jpg";